/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { GenerateTreatmentPlanPdfErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const generateTreatmentPlanPdf = (encounterId: number, signal?: AbortSignal) => {
  return api<Blob>({
    url: `/api/encounters/${encounterId}/treatment-plan-pdf`,
    method: 'POST',
    responseType: 'blob',
    signal,
  });
};

export const getGenerateTreatmentPlanPdfMutationOptions = <
  TError = GenerateTreatmentPlanPdfErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateTreatmentPlanPdf>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateTreatmentPlanPdf>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['generateTreatmentPlanPdf'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateTreatmentPlanPdf>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return generateTreatmentPlanPdf(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateTreatmentPlanPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateTreatmentPlanPdf>>
>;

export type GenerateTreatmentPlanPdfMutationError = GenerateTreatmentPlanPdfErrorResponse;

export const useGenerateTreatmentPlanPdf = <
  TError = GenerateTreatmentPlanPdfErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateTreatmentPlanPdf>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateTreatmentPlanPdf>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions = getGenerateTreatmentPlanPdfMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
